// extracted by mini-css-extract-plugin
export default {"row":"ResultsWrapper_row__7lQPq","rowMarginTop":"ResultsWrapper_rowMarginTop__Hv81a","rowMarginBottom":"ResultsWrapper_rowMarginBottom__Apjg+"};